import { render, staticRenderFns } from "./AssistantConfig.vue?vue&type=template&id=74b665fa&scoped=true&"
import script from "./AssistantConfig.vue?vue&type=script&lang=js&"
export * from "./AssistantConfig.vue?vue&type=script&lang=js&"
import style0 from "./AssistantConfig.vue?vue&type=style&index=0&id=74b665fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b665fa",
  null
  
)

export default component.exports